'use client'

import dynamic from 'next/dynamic'
import type { ToastContainerProps } from 'react-toastify'

const DynamicToastContainer = dynamic(() =>
	import('react-toastify').then((mod) => mod.ToastContainer),
)

export const LazyToastContainer = (props: ToastContainerProps) => (
	<DynamicToastContainer {...props} />
)
